var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.254,14.802L5.927,8.264 c0,0-0.384-1.115-1.639-0.801c0,0-1.291,0.244-0.941,1.952l0.73,2.008l1.309,2.702l0.909,1.959c0,0,0.261-1.933,2.038-1.264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.624,15.204l-1.465-4.672 c0,0-0.318-1.679-1.914-1.222c0,0-1.452,0.353-0.806,2.197l2.022,7.673l3.871,3.574c0,0,0.837,0.593,0.645,2.738l5.667,0.035 v-5.441c0,0,0.035-1.813-2.023-2.79L8.333,14.82c0,0-1.186-0.626-1.883,0.628c0,0-0.523,0.838,0.349,1.64l3.173,1.951"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.254,14.802"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.208,
    y: 25.446,
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 7.192,
    height: 3.898
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.743,14.802l2.328-6.538 c0,0,0.382-1.115,1.638-0.801c0,0,1.291,0.244,0.943,1.952l-0.733,2.008l-1.307,2.702l-0.91,1.959c0,0-0.262-1.933-2.037-1.264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M25.373,15.204l1.466-4.672 c0,0,0.318-1.679,1.913-1.222c0,0,1.452,0.353,0.806,2.197l-2.023,7.673l-3.869,3.574c0,0-0.838,0.593-0.646,2.738l-5.666,0.035 v-5.441c0,0-0.035-1.813,2.022-2.79l4.29-2.476c0,0,1.186-0.626,1.883,0.628c0,0,0.523,0.838-0.35,1.64l-3.173,1.951"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.743,14.802"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.597,
    y: 25.446,
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 7.192,
    height: 3.898
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.874,3.949c0,0-3.34-3.2-6.884,0.466 c0,0-0.026,0.023-0.039,0.037L15.91,4.415C12.367,0.75,9.026,3.949,9.026,3.949C6.343,6.546,8.678,9.284,8.678,9.284l7.271,7.271 l0.001-0.001l0.002,0.001l7.271-7.271C23.223,9.284,25.635,6.8,22.874,3.949z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 16,
    cy: 8.995,
    r: 3.33
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeMiterlimit: 10
    },
    points: "13.927,9.115 15.228,10.416 18.073,7.571 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.b1dab737de71f8369e3eccd332298e6b.svg";
export { ForwardRef as ReactComponent };